import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import moment from 'moment';
import { BarnyardIcon } from 'barnyard/icons';
import AlertItem from './AlertItem';
import NewVendorTable from './NewVendorTable';


const NewVendorAlert = ({ alert, ...other }) => (
  <AlertItem
    alert={alert}
    date={moment(alert.date).format('MMMM Do, YYYY')}
    icon={<BarnyardIcon icon={['fa', 'calendar-times']} className='DiscussCard__replyIcon dea' />}
    title={(
      <div>
        <Link to={`/corporate/analyze/buyer/${alert.buyer.id}`}>
          {alert.buyer.name}
        </Link>
        {' '} added a new vendor after {' '}
        <strong className='u-colorRed'>
          {alert.value.date}
        </strong>
      </div>
    )}
    content={(
      <NewVendorTable
        includeExport={true}
        credentials={alert.value.credentials}
      />
    )}
    {...other}
  />
);

NewVendorAlert.propTypes = {
  alert: PropTypes.object.isRequired,
  onIsDeletedChange: PropTypes.func.isRequired,
  onIsFlaggedChange: PropTypes.func.isRequired
};

export default NewVendorAlert;
